import { Grid } from "@mui/material";
import React from "react";

const CancelledIcon = () => {
  return (
    <Grid container alignItems="center" sx={{ height: "15px" }}>
      <Grid item>
        <svg
          width="17"
          height="15"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#2k8mea1iwa)">
            <path
              d="M8.667 0c-4.424 0-8 3.576-8 8 0 4.424 3.576 8 8 8 4.424 0 8-3.576 8-8 0-4.424-3.576-8-8-8zm4 10.872L11.539 12 8.667 9.128 5.795 12l-1.128-1.128L7.539 8 4.667 5.128 5.795 4l2.872 2.872L11.539 4l1.128 1.128L9.795 8l2.872 2.872z"
              fill="#000"
            />
          </g>
          <defs>
            <clipPath id="2k8mea1iwa">
              <path fill="#fff" transform="translate(.667)" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </svg>
      </Grid>
    </Grid>
  );
};

export default CancelledIcon;
